/* RESPONSIBLE TEAM: team-automation-foundations */
import FinAIAgentTaskRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/tasks/task';

export default FinAIAgentTaskRoute;
